import { render, staticRenderFns } from "./stuTrainStat.vue?vue&type=template&id=3971f87b&scoped=true&"
import script from "./stuTrainStat.vue?vue&type=script&lang=js&"
export * from "./stuTrainStat.vue?vue&type=script&lang=js&"
import style0 from "./stuTrainStat.vue?vue&type=style&index=0&id=3971f87b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971f87b",
  null
  
)

export default component.exports